<button
  mat-icon-button
  (click)="onClickPreview()"
  [ngClass]="{ 'pdf-preview-open': previewOpen }"
>
  <mat-icon>picture_as_pdf</mat-icon>
</button>
